export const STATUS_CODE_MAP = [
  {
    name: 'all',
    text: 'All'
  },
  {
    name: 'open',
    text: 'Open'
  },
  {
    name: 'under_investigation',
    text: 'Under Investigation'
  },
  {
    name: 'closed',
    text: 'Closed'
  }
];

export const individualColumnData = [
  {
    id: 'col00',
    name: 'alertId',
    value: 'Alert ID',
    group: [
      {
        name: 'alertTotalHits',
        value: 'Total Hits'
      }
    ]
  },
  {
    id: 'col01',
    name: 'primaryPartyKey',
    value: 'Customer ID',
    group: [
      {
        name: 'primaryPartyName',
        value: 'Customer Name'
      },
      {
        name: 'partyBusinessType',
        value: 'Type of Business'
      }
    ]
  },
  {
    id: 'col02',
    name: 'alertScore',
    value: 'Alert Score',
    group: [
      {
        name: 'alertLevel',
        value: 'Alert Level'
      }
    ]
  },
  {
    id: 'col03',
    name: 'partyResidenceCountry',
    value: 'Country of Residence',
    group: [
      {
        name: 'partyNationality',
        value: 'Nationality'
      },
      {
        name: 'partyBirthCountry',
        value: 'Country of Birth'
      }
    ]
  },
  {
    id: 'col04',
    name: 'partyAge',
    value: 'Age',
    group: []
  },
  {
    id: 'col05',
    name: 'segmentName',
    value: 'Segment',
    group: [
      {
        name: 'organisationUnit',
        value: 'Organization Unit'
      }
    ]
  },
  // {
  //   "id": "col06",
  //   "name": "note",
  //   "value": "Note",
  //   "group": []
  // },
  {
    id: 'col06',
    name: 'alertStatus',
    value: 'Alert Status',
    group: [
      {
        name: 'alertDate',
        value: 'Alert Date'
      },
      {
        name: 'closureDate',
        value: 'Alert Close Date'
      },
      {
        name: 'nsAlertReasonDesc',
        value: 'Alert Closure Reason'
      },
      {
        name: 'analystName',
        value: 'Analyst Name'
      }
    ]
  }
];

export const individualSubColumnData = [
  {
    id: 'col00',
    name: 'predictionType',
    value: 'Prediction',
    group: [
      {
        name: 'p_type',
        value: 'Type'
      }
    ]
  },
  {
    id: 'col01',
    name: 'wcId',
    value: "WC UID's",
    group: []
  },
  {
    id: 'col02',
    name: 'hitScore',
    value: 'Hit Score',
    group: [
      {
        name: 'levenshteinDistanceScore',
        value: 'Levenshtein Score'
      },
      {
        name: 'aliasScore',
        value: 'Alias Score'
      }
    ]
  },
  {
    id: 'col03',
    name: 'wc_name',
    value: 'WC Name',
    group: [
      {
        name: 'lastName',
        value: 'Last Name'
      },
      {
        name: 'firstName',
        value: 'First Name'
      },
      {
        name: 'location',
        value: 'Location'
      }
    ]
  },
  {
    id: 'col04',
    name: 'nationality',
    value: 'Nationality',
    group: [
      {
        name: 'countryOfBirth',
        value: 'Country of Birth'
      }
    ]
  },
  {
    id: 'col05',
    name: 'gender',
    value: 'Gender',
    group: []
  },
  {
    id: 'col06',
    name: 'age',
    value: 'Age',
    group: []
  },
  {
    id: 'col07',
    name: 'wc_note',
    value: 'Note',
    group: []
  }
];

export const individualTopInfoData = {
  left: [
    {
      label: 'Customer Name',
      alert_key: 'fullName',
      hit_key: 'wc_name'
    },
    {
      label: 'Nationality',
      alert_key: 'nationality',
      hit_key: 'wc_nationality'
    },
    {
      label: 'Gender',
      alert_key: 'gender',
      hit_key: 'wc_gender'
    }
  ],
  right: [
    {
      label: 'Alias',
      alert_key: 'alias',
      hit_key: 'wc_aliases'
    },
    {
      label: 'Age',
      alert_key: 'age',
      hit_key: 'wc_age'
    },
    {
      label: 'Country of Birth',
      alert_key: 'cob',
      hit_key: 'wc_cob'
    }
  ]
};

export const corperateColumnData = [
  {
    id: 'col00',
    name: 'alertId',
    value: 'Alert ID',
    group: [
      {
        name: 'alertTotalHits',
        value: 'Total Hits'
      }
    ]
  },
  {
    id: 'col01',
    name: 'primaryPartyKey',
    value: 'Customer ID',
    group: [
      {
        name: 'primaryPartyName',
        value: 'Customer Name'
      }
    ]
  },
  {
    id: 'col02',
    name: 'alertScore',
    value: 'Alert Score',
    group: [
      {
        name: 'alertLevel',
        value: 'Alert Level'
      }
    ]
  },
  {
    id: 'col03',
    name: 'customerCountryOfOperation',
    value: 'Country of Operation',
    group: []
  },
  {
    id: 'col04',
    name: 'yearsInCorp',
    value: 'Year of Incorporation',
    group: [
      {
        name: 'countryOfIncorporation',
        value: 'Country of Incorporation'
      }
    ]
  },
  {
    id: 'col05',
    name: 'segmentName',
    value: 'Segment',
    group: [
      {
        name: 'partyBusinessType',
        value: 'Nature of Business'
      },
      {
        name: 'partyOrgUnit',
        value: 'Organization Unit'
      }
    ]
  },
  // {
  //   "id": "col06",
  //   "name": "note",
  //   "value": "Note",
  //   "group": []
  // },
  {
    id: 'col06',
    name: 'alertStatus',
    value: 'Alert Status',
    group: [
      {
        name: 'alertDate',
        value: 'Alert Date'
      },
      {
        name: 'closureDate',
        value: 'Alert Close Date'
      },
      {
        name: 'nsAlertReasonDesc',
        value: 'Alert Closure Reason'
      },
      {
        name: 'analystName',
        value: 'Analyst Name'
      }
    ]
  }
];

export const corperateSubColumnData = [
  // {
  //   "id": "col00",
  //   "name": "detectionType",
  //   "value": "Detection Type",
  //   "group": [
  //     {
  //       "name": "wc_type",
  //       "value": "Type"
  //     }
  //   ]
  // },
  {
    id: 'col01',
    name: 'wc.id',
    value: "WC UID's",
    group: []
  },
  {
    id: 'col02',
    name: 'aliasScore',
    value: 'Alias Score',
    group: [
      {
        name: 'levensteinDistScore',
        value: 'Levenshtein Score'
      }
    ]
  },
  {
    id: 'col03',
    name: 'wc.name',
    value: 'WC Corp. Name',
    group: [
      {
        name: 'wc.country',
        value: 'Location'
      }
    ]
  },
  {
    id: 'col04',
    name: 'wc.category',
    value: 'Category',
    group: [
      {
        name: 'wc.subCategory',
        value: 'Subcategory'
      }
    ]
  },
  {
    id: 'col05',
    name: 'incorporationCountryCodeWc',
    value: 'Incporation WC Country Code',
    group: []
  }
  // {
  //   "id": "col07",
  //   "name": "wc_note",
  //   "value": "Note",
  //   "group": []
  // }
];

export const corperateTopInfoData = {
  left: [
    {
      label: 'Corp. Name',
      alert_key: 'corporate.name',
      hit_key: 'corperate_name'
    },
    {
      label: 'Address',
      alert_key: 'corporate.address',
      hit_key: 'wc_location'
    }
  ],
  right: [
    {
      label: 'Industry',
      alert_key: 'corporate.segment',
      hit_key: 'industry'
    },
    {
      label: 'Date of Inc.',
      alert_key: 'corporate.incorporationDate',
      hit_key: 'years_incorp'
    }
  ]
};
